import { ColumnsType } from "antd/es/table";
import { IExportData } from "@/pages/export-list/types";
import { dateFormatter } from "project-config/utils/date-formatter";
import { DotStatus } from "@/components/dot-status";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import {
  Operation,
  OperationButton,
  OperationButtonType,
} from "@/components/operation-button";

export enum ExportStatus {
  waiting = 0,
  exporting = 1,
  success = 2,
  fail = 3,
}

const t = getTranslateNsT("exportList");

export const columns: ColumnsType<IExportData> = [
  {
    title: t("export_list_name"),
    dataIndex: "taskName",
  },
  {
    title: t("export_list_type_column"),
    dataIndex: "type",
    render: (row: ExportStatus) => {
      const t = getTranslateNsT("exportList");
      return t(`user_export_render_task_type_${row}`);
    },
  },
  {
    title: t("export_list_create"),
    dataIndex: "createTime",
    render: (row) => dateFormatter(row),
  },
  {
    title: t("export_list_status"),
    dataIndex: "status",
    render: (row: ExportStatus) => {
      const t = getTranslateNsT("exportList");
      return (
        <DotStatus
          text={t(`user_export_render_task_status_${row}`)}
          color={
            {
              [ExportStatus.waiting]: "#FF8A00",
              [ExportStatus.exporting]: "#FF8A00",
              [ExportStatus.success]: "#13CB75",
              [ExportStatus.fail]: "#FF4444",
            }[row]
          }
        />
      );
    },
  },
  {
    title: t("export_list_operation"),
    render: (_: any, row) => {
      return (
        <>
          {row.status === ExportStatus.success && (
            <OperationButton
              style={{ color: "#13CB75" }}
              operation={Operation.Download}
            />
          )}
          <OperationButton
            operation={Operation.Delete}
            type={OperationButtonType.Danger}
          />
        </>
      );
    },
  },
];
